import { render, staticRenderFns } from "./searchContent.vue?vue&type=template&id=64f15d98&scoped=true"
import script from "./searchContent.vue?vue&type=script&lang=js"
export * from "./searchContent.vue?vue&type=script&lang=js"
import style0 from "./searchContent.vue?vue&type=style&index=0&id=64f15d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f15d98",
  null
  
)

export default component.exports